<template>
  <div
    v-if="baseGroupCombos && baseGroupCombos.length > 0"
    class="tag-listing-filters-container"
  >
    <div
      v-for="group in baseGroupCombos"
      :key="group.tagGroupId"
      class="tag-listing-filters-group"
    >
      <GroupFilter
        class="tag-listing-filters-group-wrapper"
        :group="group"
        :entries="group.tags"
        :is-base-group="true"
      >
      </GroupFilter>
    </div>

  </div>
</template>

<script>
import GroupFilter from './GroupFilter'

export default {
  name: 'BaseGroupListingFilters',
  components: {
    GroupFilter
  },
  props: {
    baseGroupCombos: {
      type: Array
    }
  }
}
</script>
